import { render, staticRenderFns } from "./HazardList.vue?vue&type=template&id=8a78e5d8"
import script from "./HazardList.vue?vue&type=script&lang=js"
export * from "./HazardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports